export default "__VITE_ASSET__DPGfxxyG__"